/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowplacesearch3Inputs */

const en_aiflowplacesearch3 = /** @type {(inputs: Aiflowplacesearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Search an address or place`)
};

const de_aiflowplacesearch3 = /** @type {(inputs: Aiflowplacesearch3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adresse oder Ort suchen`)
};

/**
* | output |
* | --- |
* | "Search an address or place" |
*
* @param {Aiflowplacesearch3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowplacesearch3 = /** @type {((inputs?: Aiflowplacesearch3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowplacesearch3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowplacesearch3(inputs)
	return de_aiflowplacesearch3(inputs)
});
export { aiflowplacesearch3 as "aiFlowPlaceSearch" }